import { Dispatch, SetStateAction } from 'react';

import { ListingType } from 'algolia-api/types/ListingType';
import { SearchLocation } from 'algolia-api/types/SearchLocation';
import { StaffTypeFilter } from 'algolia-api/types/StaffTypeFilter';
import { Button } from 'components/Button/Button';
import { H4 } from 'components/Text/H4';
import { colors } from 'theme';
import { DisplayedType } from 'utils/constants';

import {
  MobileSearchMenuContainer,
  MobileSearchMenuHeader,
  MobileSearchMenuWrapper,
} from './MobileSearchMenu.styled';
import { PageHeaderSearchInputs } from './PageHeaderSearchInputs';
import { PopularSearches } from './PopularSearches';

type Props = {
  onClose: () => void;
  onSearch: () => void;
  searchOpen: boolean;
  selectedType: DisplayedType;
  listingTypes: DisplayedType[];
  clearSearchInput: () => void;
  query: string;
  onLocationChange: (arg0: SearchLocation | null | undefined) => void;
  setListingType: Dispatch<SetStateAction<StaffTypeFilter>>;
  search: (query: string) => void;
  searchLocation: SearchLocation;
  setUserQuery: (q: string) => void;
  showPopularSearches?: boolean;
};

export function MobileSearchMenu({
  onClose,
  onSearch,
  searchOpen,
  selectedType,
  listingTypes,
  clearSearchInput,
  query,
  onLocationChange,
  setListingType,
  search,
  searchLocation,
  setUserQuery,
  showPopularSearches = false,
}: Props) {
  return (
    <MobileSearchMenuContainer
      $open={searchOpen}
      data-qa-id="mobile-search-menu"
    >
      <MobileSearchMenuHeader>
        <H4 mb={0} color={colors.brandBlue}>
          {getText('Search')}
        </H4>
        <Button
          data-qa-id="close-mobile-search"
          onClick={onClose}
          aria-label={getText('Close search')}
          variant="tertiary"
          noPadding
          iconName="close"
        />
      </MobileSearchMenuHeader>

      <MobileSearchMenuWrapper>
        <PageHeaderSearchInputs
          onSearch={onSearch}
          selectedType={selectedType}
          listingTypes={listingTypes}
          clearSearchInput={clearSearchInput}
          search={search}
          query={query}
          searchLocation={searchLocation}
          setListingType={setListingType}
          setQuery={setUserQuery}
          onLocationChange={onLocationChange}
        />
      </MobileSearchMenuWrapper>
      {showPopularSearches ? (
        <PopularSearches
          selectedType={selectedType as ListingType}
          search={search}
          onSearch={onClose}
          setQuery={setUserQuery}
        />
      ) : null}
    </MobileSearchMenuContainer>
  );
}
